/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

export type DensityImageSources = {
  mobile?: string;
  tablet?: string;
  desktop?: string;
};

export const parseDensitySrcSet = (srcSet?: string): DensityImageSources => {
  if (!srcSet) {
    return {};
  }

  return srcSet.split(',').reduce<DensityImageSources>((acc, item) => {
    const [url, descriptor] = item.trim().split(/\s+/);

    if (!url || !descriptor) {
      return acc;
    }

    if (descriptor === '1x') {
      acc.mobile = url;
    }

    if (descriptor === '2x') {
      acc.tablet = url;
    }

    if (descriptor === '3x') {
      acc.desktop = url;
    }

    return acc;
  }, {});
};
